import ComponentHelper from '../../supers/ComponentHelper';
import RESTService from '../../services/RESTService';
import React from 'react';
import './idp-config.css';
import CodeEditor from '../../components/code-editor/CodeEditor';
import RoutingService from '../../services/RoutingService';
const connect = new RESTService();
const RS = new RoutingService();

class IDPConfig extends ComponentHelper {
	constructor(props) {
		super(props);
		this.data = {
			config: null,
			validJson: true,
			editor: null
		};
	}

	componentDidMount() {
		connect
			.getIDPconfig()
			.then(res => {
				if (res.data) {
					this.setData('config', JSON.stringify(res.data, undefined, 2));
				}
			})
			.catch(err => {
				RS.smartError(err);
			});
	}

	checkForErrors = () => {
		setTimeout(() => {
			let decorations = this.editor.getModel().getAllDecorations();
			let error = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
			this.observe(() => {
				this.data.validJson = error.length <= 0;
			});
		}, 1500);
	};

	handleConfigChange = newValue => {
		let error = [];
		console.log(this.data);
		if (this.data.editor) {
			let decorations = this.editor.getModel().getAllDecorations();
			error = decorations
				.filter(decorations => {
					return decorations.options.className === 'redsquiggly';
				})
				.map(e => e);
		}
		this.observe(() => {
			this.data.config = newValue;
			this.data.validJson = error.length <= 0;
		});
		this.checkForErrors();
	};

	saveConfig = () => {
		connect
			.updateAppConfigSegment('security.provider', JSON.parse(this.data.config), RS.getCurrentApplication())
			.then(() => {
				RS.showSuccess();
			})
			.catch(err => {
				RS.smartError(err);
			});
	};

	render() {
		const { config, validJson } = this.data;

		return (
			<div className="idp-config-view animated fadeIn">
				<div className="hbox">
					<div className="vbox vcenter grow-1 m-b-10">
						<h1 className="title">
							Identity Providers <span>{RS.getCurrentEnvironment()}</span>
						</h1>
						<div className="sub-title">
							Here you can put all the configuration the application needs for the federation auth provider you want to integrate in your app.
						</div>
					</div>
					{config && (
						<button className="btn primary" onClick={this.saveConfig} disabled={!validJson}>
							Save
						</button>
					)}
				</div>
				{!config && <div className="err-txt">Unable to configure IDP until an application has been installed.</div>}
				{config && <CodeEditor language="json" value={config} className="editor-ctn" onChange={this.handleConfigChange} registerTo={this} />}
			</div>
		);
	}
}

export default IDPConfig;



// WEBPACK FOOTER //
// ./src/views/idp-config/IDPConfig.js